import { Injectable } from '@angular/core';
import { States } from '@socrates/common';

@Injectable()
export class StatesService {

	// TODO: replace service with simple instance
	// (realized I don't have to translate state names.. always in English)
	translateToAbbreviation(name: string): string {
		return States.translateToAbbreviation(name);
	}

	getFullStateName(abbrev: string): string {
		return States.getFullStateName(abbrev);
	}

	get states(): any[] {
		return States.states;
	}
}

